import Entity from '../entity'
export default class Closure extends Entity<number> {
    startDate: Date = null;
    endDate: Date = null;
    startTime: number = null;
    endTime: number = null;
    reason: string = '';
    dateType: string = '';
    courtId: number = 0;
    courtName: string = '';
    creationTime: Date = null;
    creatorUserId: number = 0;
}